import React from "react";
import { useSelector } from "react-redux";
import { DashboardLayout } from "../../layout";
import { ForumBox, NewsBox, Users } from "../../components";
import { RegisterModal, LoginModal, SuccessModal } from "../../components/Forms";
import { ForumsData } from "./mockData";

const Home = () => {
  const { registerModal, loginModal, successModal } = useSelector(({ auth }) => auth);
  return (
    <DashboardLayout page="home">
      <div className="hidden lg:block">
        <ForumBox data={ForumsData} />
      </div>
      <div className="mt-5 hidden lg:block">
        <Users />
      </div>
      <div className="mt-0 lg:mt-5">
        <NewsBox />
      </div>
      <RegisterModal show={registerModal} />
      <LoginModal show={loginModal} />
      <SuccessModal show={successModal} />
    </DashboardLayout>
  );
};

export default Home;
